/**
 * PostGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { PostData } from './post_data'

/**
 * PostGetRes
 */
export interface PostGetRes {
  /** 帖子详情 */
  items?: PostData[]
}

/**
 * PostGetRes Schema
 */
export const PostGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '帖子详情',
      format: '[]*model.PostData',
      items: { $ref: 'PostData', description: '' },
      type: 'array',
      label: '帖子详情',
    },
  },
  type: 'object',
}
